module.exports = __webpack_public_path__ + "img/logo_BRI_2.28d20bd4.png";